<template>
  <div class="phone-preview">
    <div
      class="navigate-out-wrapper"
      :style="{ backgroundColor: navigationBg }"
      :class="{ phoneHeaderFixed }"
    >
      <div class="navigate-bar" :style="{ color: phoneHeaderFixedColor }">
        <div class="navigation-title">{{ navigationTitle }}</div>
      </div>
      <slot name="headerSlot"> </slot>
    </div>
    <div
      class="phone-body"
      :class="{ phoneBodyOverflowHidden, 'full-height': phoneHeaderFixed }"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    phoneBodyOverflowHidden: {
      type: Boolean,
      default: false
    },
    phoneHeaderFixedColor: {
      type: String,
      defalt: "#2b2b2b"
    },
    phoneHeaderFixed: {
      type: Boolean,
      default: false
    },
    navigationTitle: {
      type: String,
      default: ""
    },
    navigationBg: {
      type: String,
      default: "#fff"
    }
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style scoped lang="scss">
.phone-preview {
  position: relative;
  width: 375px;
  height: 667px;
  margin-right: 20px;
  .navigate-out-wrapper {
    &.phoneHeaderFixed {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 64px;
      z-index: 1;
    }
  }
  .navigate-bar {
    position: relative;
    width: 100%;
    height: 64px;
    background-image: url("https://imgcdn.hemiao100.com/hemiaoBase/actCenter/mpnavigarionbar.png");
    background-size: 100% 100%;
  }
  .navigation-title {
    font-size: 18px;
    position: absolute;
    top: 34px;
    left: 50%;
    transform: translateX(-50%);
  }
  .phone-body {
    height: calc(667px - 64px);
    overflow-y: auto;
    &.full-height {
      height: 667px;
    }
    &.phoneBodyOverflowHidden {
      overflow: hidden;
    }
  }
}
</style>
